import React from "react";
import { Row, Col, Typography, Space } from "antd";
import "../../assets/dist/pageHeader/LeftLayout.css";
// import ShowApplicationId from "../NewApplication/ShowApplicationId";

const { Title } = Typography;

const LeftLayout = ({ children }) =>{
  const applicationId = localStorage.getItem("ApplicationId");
  return (
  <Row>
    {/* Left Section: Hidden on xs/sm screens */}
    <Col
      xs={24}
      sm={24}
      md={24}
      lg={24}
      xl={24}
     className="left-side-full-bg"
    >

      <img
                        src={"/websiteLogo.png"}
                        alt={"Logo"}
                        className="left-side-full-bg__logo-img"
                    />
      {/* <Space style={{ width: "100%" }}>
        <img
          src="/SiteLogo11.svg"
          alt="Levridge.AI Logo"
          style={{ height: "32px" }}
        />
        <Title level={4} style={{ color: "#ffffff !important", margin: 0, marginLeft: 8 }}>
          Levridge.AI
        </Title>
      </Space> */}
      {/* <div style={{ marginTop: 64,  alignItems: "center" }} className="sitelogo-img">
        <img
          src="/SiteLogo11.svg"
          alt="Levridge.AI Logo"
          style={{ marginRight: 16,width: "60px",height:"auto"}}
        />
        <div className="footer_copyright">
          <p className="copytext">          
           </p>
        </div>

      </div> */}
      {/* Create top bar menu */}
    </Col>
    {/* Right Section: Full width on xs/sm, 50% on md+ */}
    <Col
      xs={24}
      sm={24}
      md={24}
      lg={24}
      xl={24}
      style={{
        display: "flex",
        flexDirection: "column",
        // minHeight: "100vh",
        justifyContent: "center",
       // padding: "0 6vw",
        // paddingLeft:"10vw",
        alignItems: "center",
        paddingTop: "25px"
      }}
      className="left-layout-component"
    > 
       {/* {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
  <ShowApplicationId />
)} */}

      {children}
    </Col>
  </Row>
)}

export default LeftLayout;